<template>
  <div>
    <div
      v-if="!!totalIncompleteItemCount"
      class="parvandeh-notification__toggle-button"
      :class="`${rowClass}`"
      @click.stop="handleExpanded(!expanded)"
    >
      <zoom-center-transition>
        <span
          v-if="!expanded && totalIncompleteItemCount"
          class="chips chips--error chips--pill pb-0 position-absolute top--10 right--10"
        >
          {{ totalIncompleteItemCount }}
        </span>
      </zoom-center-transition>
      <span>
        <mdicon v-if="expanded" name="close" size="24" />
        <mdicon v-else name="folder-information-outline" size="24" />
      </span>
      <span v-if="!expanded" class="parvandeh-notification__toggle-button-text">
        {{ $lang.incompleteParvandehI }}
      </span>
    </div>
    <slide-y-down-transition>
      <div
        v-if="expanded"
        :class="`parvandeh-notification mobile-none tablet-none ${
          expanded ? 'expanded' : ''
        } ${contentWrapperClass}`"
        v-click-outside="expanded && handleCloseExpanded"
      >
        <Content
          :expanded="expanded"
          :totalIncompleteItemCount="totalIncompleteItemCount"
          :percent="percent"
          :items="items"
          bodyClass="height-350"
          @getExpanded="handleExpanded"
        />
      </div>
    </slide-y-down-transition>
    <MobilePopup :show="show" minHeightPercent="60" @setShow="handleShow">
      <template>
        <div class="parvandeh-notification-mobile">
          <Content
            mode="MOBILE"
            :expanded="true"
            :totalIncompleteItemCount="totalIncompleteItemCount"
            :percent="percent"
            :items="items"
            @getExpanded="handleExpanded"
            @closeMobilePopup="handleShow"
          />
        </div>
      </template>
    </MobilePopup>
  </div>
</template>

<script>
import MobilePopup from "@/components/re-design/modal/MobilePopup.vue";
import Content from "./Content.vue";
import { getParvandehStatusDetail } from "@/services";
import {
  checkScreenDevice,
  generateError,
  generateStoreGetters,
  storeDispatcher,
} from "@/shared/utils";
import { computed, onMounted, ref, toRefs, watch } from "vue";

export default {
  components: { MobilePopup, Content },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    rowClass: {
      type: String,
      default: "",
    },
    contentWrapperClass: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // bind props
    const { code } = toRefs(props);

    // handle expanded
    const expanded = ref(false);
    const handleExpanded = (value) => (expanded.value = value);
    const handleCloseExpanded = () => handleExpanded(false);

    // handle show
    const show = ref(false);
    const handleShow = (value) => {
      show.value = value;
      storeDispatcher("showParvandehNotification", value);
    };

    // fetch data
    const totalIncompleteItemCount = ref(0);
    const percent = ref(0);
    const items = ref([]);
    const fetchData = async () => {
      try {
        const response = await getParvandehStatusDetail(code.value);
        const {
          totalIncompleteItemCount: getTotalIncompleteItemCount,
          percent: getPercent,
          items: getItems,
        } = response;
        totalIncompleteItemCount.value = getTotalIncompleteItemCount;
        percent.value = getPercent;
        items.value = getItems;
      } catch (error) {
        generateError(error);
      } finally {
        if (checkScreenDevice(["desktop"])) {
          show.value = true;
        }
      }
    };
    onMounted(() => fetchData());

    const showParvandehNotification = computed(() =>
      generateStoreGetters(["showParvandehNotification"])
    );
    watch(showParvandehNotification, (value) => {
      if (value) {
        handleShow(true);
      }
    });

    // return data to be used in template
    return {
      show,
      handleShow,
      expanded,
      handleExpanded,
      handleCloseExpanded,
      totalIncompleteItemCount,
      percent,
      items,
    };
  },
};
</script>
